import { render, staticRenderFns } from "./tinymceEditor.vue?vue&type=template&id=0c2ab1ca&scoped=true"
import script from "./tinymceEditor.vue?vue&type=script&lang=js"
export * from "./tinymceEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2ab1ca",
  null
  
)

export default component.exports